import React from "react";
import { Machine } from "../../../game/Machine";
import { formatDuration } from "../../../game/time";
import { useOperationProgress } from "./useOperationProgress";

/** The status wording in the sheet header. */
export const StatusText: React.FC<{ machine: Machine }> = ({ machine }) => {
  const { isOperating, currentPhase, minutesRemaining } =
    useOperationProgress(machine);
  const hasSwitch = machine.type.powerSwitch === true;
  const switchedOff = hasSwitch && !machine.isPowered;
  const operation = machine.selectedOperationOrNull;

  const timeLeft = `${formatDuration(minutesRemaining)} left`;

  if (isOperating) {
    if (switchedOff) {
      return (
        <span className="text-store-orange-dark">Paused · switched off</span>
      );
    }
    if (operation?.phases && currentPhase) {
      return (
        <span className="text-ink-blue">
          {currentPhase.name}
          {!currentPhase.attended && " (hands-free)"} · {timeLeft}
        </span>
      );
    }
    return (
      <span className="text-ink-blue">
        {operation?.runningName ?? "Running"} · {timeLeft}
      </span>
    );
  }
  if (switchedOff) return <>Switched off</>;
  if (hasSwitch) return <span className="text-ink-blue">Idling</span>;
  return <>Idle</>;
};
